import Layout from '@/layout'

const priceRouter = {
  path: '/price',
  component: Layout,
  name: 'price',
  meta: {
    title: '报价管理',
    icon: 'el-icon-coin',
    roles: ['root', 'market', 'business']
  },
  children: [
    {
      path: 'car_brand_manage',
      name: 'CarBrandManage',
      component: () => import('@/views/minip/car/carBrandPriceTable'),
      meta: { title: '车品牌列表', icon: 'el-icon-s-unfold', noCache: false }
    },
    {
      path: 'car_model_manage',
      name: 'CarModelManage',
      component: () => import('@/views/minip/car/carModelPriceTable'),
      meta: { title: '车型号列表', icon: 'el-icon-s-fold', noCache: false }
    },
    {
      path: 'ppf',
      name: 'PricePPF',
      component: () => import('@/views/minip/price/ppf'),
      meta: { title: '隐形车衣报价', icon: 'el-icon-refrigerator', roles: ['root', 'market', 'business'], noCache: true }
    },
    {
      path: 'ppf_args',
      name: 'ArgsNameTable',
      component: () => import('@/views/minip/price/ppf_args'),
      meta: { title: '隐形车衣部位参数', icon: 'el-icon-set-up', roles: ['root', 'market', 'business'], noCache: false }
    },
    {
      path: 'ppf_create',
      name: 'PricePPFCreate',
      component: () => import('@/views/minip/price/create_ppf'),
      meta: { title: '新增隐形车衣报价', icon: 'el-icon-refrigerator', roles: ['root', 'market', 'business'] },
      hidden: true
    }
  ]
}
export default priceRouter
